export const DEFAULT_COUNTERS = [
  { count: 0, label: 'White', type: 'white' },
  { count: 0, label: 'Blue', type: 'blue' },
  { count: 0, label: 'Black', type: 'black' },
  { count: 0, label: 'Red', type: 'red' },
  { count: 0, label: 'Green', type: 'green' },
  { count: 0, label: 'Colorless', type: 'colorless' },
  { count: 0, label: 'Storm', type: 'storm' },
];
